import React from 'react';
import Grid from '@material-ui/core/Grid';
import Footer from '../common/Footer';
import { Title, Text, Button, Divider } from '../common/styled';
import './style.css';
import mediaQuery from '../common/mediaQuery';
import images from '../../services/imagesInBase64';
import check from '../../images/home/check.png';
import MultipleSlider from './components/multipleSlider';
import ScrollAnimation from 'react-animate-on-scroll';

import Modal from '../../components/modalCapturaEmail/modal';

import board from '../../images/home/board.png';

const list = (text, imagens) => {
  const { small } = mediaQuery();

  let ret = [];
  for (let i = 1; i < 4; i++) {
    ret.push(
      <>
        {small && <Divider height="5vh" />}
        <Grid item container direction={'row'} className="Body-list">
          <Divider style={{ height: '24vh', minHeight: 30 }} />
          <Grid
            item
            xs={small ? 3 : 12}
            sm={2}
            direction="row"
            container
            justify={small ? 'center' : 'flex-start'}
            alignItems="center"
          >
            <img src={check} className="Body-check" alt="" />
          </Grid>
          <Grid
            item
            xs={small ? 9 : 12}
            sm={10}
            direction="row"
            container
            justify="center"
            alignItems="center"
          >
            <Text
              size={small ? '2.5vh' : '1.625em'}
              color="#444"
              weight={small ? '600' : '400'}
            >
              {i === 1
                ? text.getTopico1()
                : i === 2
                ? text.getTopico2()
                : text.getTopico3()}
            </Text>
          </Grid>
        </Grid>
      </>,
    );
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}> {ret} </div>
  );
};

export default ({ text, language, imagens, routeChange }) => {
  const { large, medium, small } = mediaQuery();

  return (
    <div className="Body-wrapper">
      {small && <Divider height="15vh" />}
      {/* Confiam em nosso serviço. */}
      <Grid style={{ marginBottom: '5vh' }}>
        <Grid item container justify="center" alignItems="center">
          <ScrollAnimation animateIn="bounceInDown" animateOnce={true}>
            <Title color="#444" size={small ? '3.2vh' : '6vh'} weight="100">
              {text.getTituloResumo1()}
            </Title>
          </ScrollAnimation>
        </Grid>

        <Divider height="5vh" />

        <div style={{ marginBottom: '3vh' }}>
          <ScrollAnimation animateIn="bounceInUp" animateOnce={true}>
            <MultipleSlider
              language={language}
              images={imagens}
              mediaQuery={mediaQuery}
            />
          </ScrollAnimation>
        </div>

        <Grid item container justify="center" alignItems="center">
          {/* <Divider height="20vh" /> */}

          <ScrollAnimation
            animateIn="bounceInUp"
            animateOnce={true}
            style={{ width: 400 }}
          >
            <Button
              className="btnbtn"
              color="#fff"
              border="1px solid #777"
              onClick={() => routeChange('portfolio')}
              width={large ? '15vw' : small ? '70vw' : '14vw'}
              style={{
                marginTop: 50,
                padding: '30px 10px',
                textAlign: 'center',
                margin: '0 auto',
                minWidth: 250,
                width: '100%',
              }}
            >
              <Text color="#444" size="20px">
                {text.getButtonMoreText()}
              </Text>
            </Button>
          </ScrollAnimation>
        </Grid>
      </Grid>
      {/* Section 02 - Resumo */} {/* JÃO */}
      <ScrollAnimation animateIn="slideInLeft" animateOnce={true}>
        <Grid
          container
          justify="left"
          alignItems="center"
          alignContent="center"
          // className={large ? "Body-section1-home" : small ? "Body-section1-home-mobile" : "Body-section1-home"}
          className={'Body-section1-home-mobile'}
          style={{ height: large ? '50vh' : '100vh' }}
        >
          {/* {large && (
          <>
            <Grid item xs={5} sm={7}>
              
                <Text
                  size="25px"
                  lineHeight="7vh"
                  color="#fff"
                  weight="700"
                  align="left"
                >
                  {text.getTextoHome1()}
                </Text>

                <Button 
                  className="KnowMoreAbout"
                  maxWidth="10000px"
                  width="6vw"
                  height='5vh'
                  onClick={() => routeChange('quem-somos')}
                >
                  {text.getBotao2()}
                </Button>
            </Grid>
          </>
          )} */}

          {/* {small && ( */}
          <Grid item xs={12} sm={12}>
            <ScrollAnimation animateIn="bounceInLeft" animateOnce={true}>
              <Text
                size={small ? '3vh' : '4vh'}
                lineHeight="7vh"
                color="#fff"
                weight="700"
                align="left"
              >
                {text.getTextoHome1()}
              </Text>

              <Button
                className="KnowMoreAbout"
                onClick={() => routeChange('quem-somos')}
              >
                {text.getBotao2()}
              </Button>
            </ScrollAnimation>
          </Grid>
          {/* )} */}
        </Grid>
      </ScrollAnimation>
      <Divider style={{ minHeight: 30, height: '15vh' }} />
      {/* FIQUE TRANQUILO COM OS DADOS */}
      <Grid
        container
        justify="center"
        alignItems="center"
        className="Body-section-2-home"
      >
        <Grid
          item
          xs={12}
          sm={12}
          container
          justify="center"
          alignItems="center"
        >
          <ScrollAnimation animateIn="bounceInDown" animateOnce={true}>
            <Title
              weight="900"
              transform="uppercase"
              color="#444"
              size="4vh"
              padding={small ? '0 5vw' : 0}
            >
              {text.getTituloResumo2()}
            </Title>
          </ScrollAnimation>
        </Grid>

        {!small && <Divider height="10vh" />}

        <div
          style={{
            display: 'flex',
            flexDirection: small ? 'column' : 'row',
            alignItems: 'flex-start',
          }}
        >
          <Grid
            item
            xs={12}
            sm={7}
            container
            justify="center"
            alignItems="center"
          >
            <ScrollAnimation animateIn="bounceInLeft" animateOnce={true}>
              <img
                src={board}
                className="Body-imageBoard"
                style={small ? { height: '50vh', marginTop: '10vh' } : {}}
                alt=""
              />
            </ScrollAnimation>
          </Grid>

          <Grid
            item
            xs={12}
            sm={5}
            container
            justify="center"
            alignItems="center"
            className="Body-section-2-home"
          >
            <ScrollAnimation animateIn="bounceInRight" animateOnce={true}>
              {list(text, imagens)}
            </ScrollAnimation>
            <Divider height="100px" />
            <Button
              width="200px"
              height="40px"
              color="#eee"
              border="1px solid #58b711"
              radius="25px"
              onClick={() => routeChange('servicos')}
            >
              <Text align="center" color="#58b711" weight="900" size="1.375em">
                {text.getBotao2()}
              </Text>
            </Button>
            <Divider height="100px" />
          </Grid>
        </div>
      </Grid>
      <Footer text={text} language={language} />
      {language && language === 'us' && <Modal />}
    </div>
  );
};
